module.exports = __webpack_public_path__ + "bin/1c6ab523648d22c0a9a601bf48a68bb1.jpg";